export default __webpack_public_path__ + "static/media/appLogo2V2.4ca0d643.png";